module.exports = __webpack_public_path__ + "assets/img/sharefrend.8d8f7602.png";